module.exports = __webpack_public_path__ + "media/images/pic/testimonials/blank-5ac428f6da55c9510ec5eec3b6b6df1f.jpg";